import React, { useState }  from 'react'
import { Dropdown, Grid, Button, Modal, Form,Label, Icon ,Image} from 'semantic-ui-react'

const options = [
    { key: 'm', text: 'Male', value: 'male' },
    { key: 'f', text: 'Female', value: 'female' },
    { key: 'o', text: 'Other', value: 'other' },
  ]

const  ModalImprovement = (props) =>  {
  const [files, setFiles] = useState([]);

  const fileChange = e => {
    if (e.target.files) {
      let tab = Object.values(e.target.files).map(file => {
        return {
          ...file,
          url: URL.createObjectURL(file)
        }
      })
    setFiles([...files, ...tab]);
  }
  };
  const deleteFile = (file) => {
    const swap = [...files]
    const indexToDelete = swap.indexOf(file);
    if (indexToDelete !== -1)
    swap.splice(indexToDelete, 1)
    setFiles(swap)
  }

  return (
    
      <Modal
      onClose={props.onClose}
      dimmer="blurring"
      basic
      open={props.open}
      >
        <Grid> 
          <Grid.Column >
            <div style={styles.modalContainer}>
              <Form >
                <Modal.Header>
                  <div style={styles.label}>{props.selectLabel}</div>
                  <Dropdown
                  style={styles.selectContainer}
                  options={options}
                  selection
                  placeholder={props.selectPlaceHolder}
                  />
                </Modal.Header>
                <div style={styles.label}>Une ressource à joindre ?</div>
                <Image.Group size='small'>
                {files.map((file, index)=> <Image 
                                            size='huge'  
                                            centered={true} 
                                            label={<Label 
                                                      ribbon
                                                      onClick={() => deleteFile(file)}
                                                      color='red' 
                                                      icon='delete'>
                                                      </Label>}
                                            style={styles.imgStyle} 
                                            rounded={true} 
                                            key={index} 
                                            src={file.url}/>
                          )
                }
              </Image.Group>
                <Button style={styles.uploadInput}  size="large" as="label" htmlFor="file" type="button" animated="fade">
                  <Button.Content visible>
                    <Icon name="add" color="blue"/>
                  </Button.Content>
                  <Button.Content hidden>Fichier(s)</Button.Content>
                </Button>
                <input
                  type="file"
                  id="file"
                  accept=".jpeg,.jpg,.png,.svg,.gif"
                  hidden
                  onChange={fileChange}
                  // onChange={this.fileChange}
                />    
                <div style={styles.label}>{props.textAreaLabel}</div>
                <Form.TextArea
                fluid="true"
                size={5}
                style={styles.inputContainer}
                />
              </Form>
            </div>
            <Button size="large" onClick={props.onClose} style={styles.button}  floated='right'>Envoyer</Button>
          </Grid.Column>
        </Grid>
      </Modal>
  )
}

const styles = {
    modalContainer: {
        padding: '5%',
        backgroundColor:'white',
        borderRadius: "20px",
        boxShadow:" 0px 7px 20px #00000029",
    },
    inputContainer: {
        minHeight: "40vh",
        borderRadius: "10px",
        boxShadow:" 0px 7px 20px #00000029",
    },
    uploadInput: {
      // padding: '10px',
      marginBottom: '3vh',
      marginTop: "2vh"

    },
    imgStyle: {
      boxShadow:" 0px 17px 20px #00000029",
      margin: '1vw'
    },
    button: {
        borderRadius: "10px",
        marginTop: "2vh",
        backgroundColor: '#6CADDF',
        color: 'white',
        boxShadow:" 0px 1px 30px white",
    },
    label: {
        color: "#000000",
        opacity: "0.75",
        font: "normal normal bold 15px/34px Helvetica",
        letterSpacing: "0px"
    },
    selectContainer: {
        borderRadius: "10px",
        marginBottom: '3vh',
        minHeight: "4vh",
        padding:"10px",
        boxShadow:" 0px 7px 20px #00000029",
    }
}


export default ModalImprovement